import * as React from "react";
import {
    ElevationStyledInputBase,
    IconButtonClear,
    OverlayStyledInputBase,
    Search,
} from "./SearchTextField.styles";
import { SearchTextFieldOpts } from "./SearchTextField.types";
import { useRef } from "react";
import { useMapSearchFieldStore } from "../../../Infrastructure/Persistence/MapSearchFieldStore";
import { CircleXMarkIcon } from "../Icon/CircleXMarkIcon";
import { SearchIcon } from "../Icon/SearchIcon";

export const DEFAULT_DEBOUNCE_MILLISECONDS = 700;

export default function (props: SearchTextFieldOpts) {
    const {
        placeholder = "Search...",
        searchInput: searchField = "",
        onSearch = (value: string) => {},
        showElevation = true,
    } = props;
    const showClear = searchField && searchField.length > 0;
    const searchInputRef = useRef<HTMLInputElement>();
    const { blurSearchInputField, setBlurSearchInputField } =
        useMapSearchFieldStore((state) => state);

    if (blurSearchInputField) {
        searchInputRef.current?.blur();
        setBlurSearchInputField(false);
    }

    const styledInputBase = {
        placeholder: placeholder,
        onClick: () => {
            props.onClick?.(true);
            if (window.scrollY) {
                window.scrollTo({
                    top: 0,
                    behavior: "smooth",
                });
            }
        },
        onChange: ({ target }) => {
            onSearch(target.value);
        },
        value: searchField,
        id: "contentSearchBar",
        inputRef: searchInputRef,
    };

    return (
        <Search>
            {showElevation ? (
                <ElevationStyledInputBase {...styledInputBase} />
            ) : (
                <OverlayStyledInputBase
                    startAdornment={
                        <SearchIcon
                            color={"var(--community-color-secondary-text)"}
                            width="20px"
                            height="20px"
                        />
                    }
                    {...styledInputBase}
                />
            )}
            {showClear && (
                <IconButtonClear
                    onClick={() => {
                        onSearch("");
                        props.onClick?.(false);
                        searchInputRef.current?.blur();
                    }}
                >
                    <CircleXMarkIcon fill="var(--community-color-transparent-black-20)" />
                </IconButtonClear>
            )}
        </Search>
    );
}
